import React from "react";
import {
  Image,
  ImageBackground,
  Modal,
  Text,
  TouchableOpacity,
  View,
} from "react-native";

import style from "./style";
import globalstyle from "../../Styles/Globals/globals";
import { getRecursText, getRecursURL } from "../../Functions/getRecurs";

function PopUpInicial(RouterData, modalVisible, setModalVisible) {
  const { recursos, idioma, itinerari } = RouterData.route.params;

  return (
    <Modal animationType="fade" transparent={true} visible={modalVisible}>
      <View style={style.modalOutBackground}>
        <View style={[style.caixaPopUp, { height: "80%" }]}>
          <ImageBackground
            source={{
              uri: getRecursURL(recursos, "05_background_tipus2", idioma),
            }}
            style={style.backgroundImatges}
          >
            {/* Close button */}
            <TouchableOpacity
              style={globalstyle.crossBox}
              onPress={() => setModalVisible(false)}
            >
              <Image
                source={{
                  uri: getRecursURL(recursos, "pop_up_close_icon", idioma),
                }}
                style={style.cross}
              />
            </TouchableOpacity>

            {/* Header */}
            <View style={{ flex: 40, alignItems: "center", width: "85%" }}>
              {/*{*/}
              {/*  <ImageBackground*/}
              {/*    style={{*/}
              {/*      width: "100%",*/}
              {/*      height: "100%",*/}
              {/*      alignItems: "center",*/}
              {/*      justifyContent: "center",*/}
              {/*    }}*/}
              {/*    resizeMode={"contain"}*/}
              {/*    source={{*/}
              {/*      uri: getRecursURL(recursos, "fons_text_default", idioma),*/}
              {/*    }}*/}
              {/*  >*/}
              {/*    <Text style={style.popUpTitleInicial}>*/}
              {/*      {itinerari["Nom" + idioma]}*/}
              {/*    </Text>*/}
              {/*  </ImageBackground>*/}
              {/*}*/}
            </View>

            {/* Body */}
            <View
              style={{ flex: 50, alignItems: "center", alignSelf: "center" }}
            >
              <Text style={style.popUpMapaText}>
                {getRecursText(recursos, "popup_inici_itinerari_2", idioma)}
              </Text>
              <Image
                style={style.imageFlag}
                source={{
                  uri: getRecursURL(recursos, "itinerari_punt_inici", idioma),
                }}
              />
            </View>

            {/* Footer */}
            <View style={{ flex: 10 }}>
              <TouchableOpacity
                onPress={() => {
                  setModalVisible(false);
                }}
              >
                <Text style={globalstyle.botoContinuar}>
                  {getRecursText(recursos, "text_continuar", idioma)}
                </Text>
              </TouchableOpacity>
            </View>
          </ImageBackground>
        </View>
      </View>
    </Modal>
  );
}

export default PopUpInicial;
